import { action, makeObservable, observable } from 'mobx';
import { ICompositeProductApi } from '@canvas-logic/clp-sdk';

import { ICompositeProductData } from '@canvas-logic/clp-domain';

import { IUICfgUICompositeProductInfoElementUI } from '@canvas-logic/clp-api-types';
import { ElementState } from '@/elements/base/ElementState';

let id = 0;

export interface Color {
  ral: string;
  hex: string;
}

export class CompositeProductInfoState extends ElementState {
  readonly elementKind = 'ui-element';
  readonly elementType = 'composite-product-info';
  public id = 'composite-product-info-state-' + ++id;

  loading = false;
  productData: ICompositeProductData;

  constructor(public readonly api: ICompositeProductApi, public viewElement: IUICfgUICompositeProductInfoElementUI) {
    super();

    makeObservable(this, {
      loading: observable,
      update: action.bound,
    });

    this.productData = this.api.getProductData();
  }

  get title(): string {
    return this.productData.texts.name;
  }

  get description(): string {
    return this.productData.texts.description;
  }

  get shortDescription() {
    return this.productData.texts.shortDescription;
  }
}
